import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { Message } from 'element-ui'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    activeId: 0, // 手机底部选中的id
    userInfo: {},
    token: '',
    searchList: [{}],
    videoTypeId: 1, // 0素材1成片
    videoTypeList: {}, // 全部分类视频
    // 新闻类
    newsList: {},
    // 直播类
    liveList: {},
    // 访谈类
    viewList: {},
    // 作品类
    workList: {},
    // 其他类
    otherList: {},
    // 视频播放总量
    videoGrossCount: {},
    searchCount: [], // 搜索量
    playList: [], // 播放量
    dowloadList: [], // 下载量
    // 【高级搜索】
    videoTwoCate: [], // 门类检索列表
    checkList: '', // 选中的门类检索
    checkedOneList: '', // 选中的分类检索名称
    videoOneValue: '', // 选中的分类名称简介NEWS 。。。
    videoPerson: [], // 人物检索列表
    checkedPersonList: '', // 选中的人物
    organizationList: [], // 机构列表
    videoList: [],
    showMode: 0, // 视频显示模式 0单视频1视频集
    page: 1,
    limit: 10,
    startTime: '',
    endTime: '',
    organizationLike: '',
    retrieval: '',
    address: '',
    activeName: '',
    highSearchData: '', // 高级检索的data
    // 高级检索的回显数据
    searchData: {
      videoOneValue: [], // 检索类型
      videoCategory: [], // 文艺门类
      activeName: '', // 活动检索
      personNameLike: '', // 人物检索
      address: [], // 地点检索
      orgvalue: Array, // 机构检索
      videoDate: [], // 时间检索
      retrieval: '', // 综合检索
      showMode: '0', // 结果显示模式
      videoTypeId: '', // 数据来源
      page: 1
    },
    isModeStatus: 0,
    // 公告
    noticeArray: [],
    // 手机端加载更多后的回显
    moreVideoList: [],
    // 下线搜索
    offlineType: '',
    // 判断是否是回退键
    isBack: false,
    tabname: null,
    currentpage:1,
    tabactiveid:0
  },
  mutations: {
    // 清空高级搜索数据
    clearSearchObj: function (state) {
      var obj = {
        videoOneValue: [], // 检索类型
        videoCategory: [], // 文艺门类
        activeName: '', // 活动检索
        personNameLike: '', // 人物检索
        address: '', // 地点检索
        orgvalue: Array, // 机构检索
        videoDate: [], // 时间检索
        retrieval: '', // 综合检索
        showMode: '0', // 结果显示模式
        videoTypeId: '', // 数据来源
        page: 1
      }
      state.retrieval = ''
      state.address = ''
      state.organizationLike = ''
      state.activeName = ''
      state.searchData = obj
    },
    // state,同步
    // 成片素材
    changeTypeId: function (state, typeId) {
      state.videoTypeId = typeId
      // alert(state)
      // console.log(state)
      // console.log(typeId)
    },
    // 门类检索
    getDoorType: function (state, list) {
      state.checkList = list
    },
    getVideoTwoCate: function (state, list) {
      state.videoTwoCate = list
    },
    // 分类检索
    getClassType: function (state, str) {
      state.checkedOneList = str
    },
    // 人物列表
    changePersonList: function (state, params) {
      state.videoPerson = params
    },
    checkedPerson: function (state, params) {
      state.checkedPersonList = params
    }
  },
  actions: {
    // 异步
    // 退出登录
    logout: function () {
      axios.post('/v1/bqUser/logout')
        .then(res => {
          var { code, message } = res.data
          if (code == 0) {
            Message.success('退出登录！')
            // window.location.href = '/login'
          } else {
            Message.error(message)
          }
        }).catch(() => { })
    },
    // 获取首页分类列表
    getListByContent: function (context) {
      // console.log(context)
      // context.commit('getListByContent')
      if (context.state.videoTypeId == '') {
        context.state.videoTypeId = 0
      }
      axios.get(`/v1/index/videoInfoByContentType?videoTypeId=${context.state.videoTypeId}`).then(res => {
        var { code, message, data } = res.data
        if (code === 0) {
          // console.log(data)
          context.state.videoTypeList = data
          // 成片库 素材库
          context.state.otherList = data.OTHER
          if (JSON.stringify(context.state.otherList) !== '{}') {
            if (context.state.otherList.videoInfoList.length > 4) {
              context.state.otherList.videoInfoList = context.state.otherList.videoInfoList.slice(
                0,
                4
              )
            }
          } else {
            context.state.otherList = JSON.stringify(data.OTHER)
          }
          context.state.newsList = data.NEWS
          // console.log(this.newsList);
          if (JSON.stringify(context.state.newsList) !== '{}') {
            if (context.state.newsList.videoInfoList.length > 4) {
              context.state.newsList.videoInfoList = context.state.newsList.videoInfoList.slice(
                0,
                4
              )
            }
          } else {
            context.state.newsList = JSON.stringify(data.NEWS)
          }
          context.state.viewList = data.VIEW
          if (JSON.stringify(context.state.viewList) !== '{}') {
            if (context.state.viewList.videoInfoList.length > 4) {
              context.state.viewList.videoInfoList = context.state.viewList.videoInfoList.slice(
                0,
                4
              )
            }
          } else {
            context.state.viewList = JSON.stringify(data.VIEW)
          }
          context.state.workList = data.WORKS
          if (JSON.stringify(context.state.workList) !== '{}') {
            if (context.state.workList.videoInfoList.length > 4) {
              context.state.workList.videoInfoList = context.state.workList.videoInfoList.slice(
                0,
                4
              )
            }
          } else {
            context.state.workList = JSON.stringify(data.WORKS)
          }
          context.state.liveList = data.LIVE
          if (JSON.stringify(context.state.liveList) !== '{}') {
            if (context.state.liveList.videoInfoList.length > 4) {
              context.state.liveList.videoInfoList = context.state.liveList.videoInfoList.slice(
                0,
                4
              )
            }
          } else {
            context.state.liveList = JSON.stringify(data.LIVE)
          }
          // 热数据排行榜 DOWNLOADS PLAYCOUNT VIEWCOUNT
          // context.state.searchCount = data.VIEWCOUNT.slice(0, 6);
          // context.state.playList = data.PLAYCOUNT.slice(0, 6);
          // context.state.dowloadList = data.DOWNLOADS.slice(0, 6);
        } else {
          Message.error(message)
        }
      })
    },
    getListByTop: function (context) {
      // console.log(context)
      // context.commit('getListByContent')
      axios.get(`/v1/index/videoInfoByContentType?videoTypeId=${context.state.videoTypeId}`).then(res => {
        var { code, message, data } = res.data
        if (code === 0) {
          // console.log(data)
          context.state.videoTypeList = data
          // 热数据排行榜 DOWNLOADS PLAYCOUNT VIEWCOUNT
          context.state.searchCount = data.VIEWCOUNT.slice(0, 6)
          context.state.playList = data.PLAYCOUNT.slice(0, 6)
          context.state.dowloadList = data.DOWNLOADS.slice(0, 6)
        } else {
          Message.error(message)
        }
      })
    },
    // 视频播放总量
    videoInfoGrossCount: function (context) {
      axios.get(`/v1/index/videoInfoGrossCount`).then(res => {
        var { code, data, message } = res.data
        if (code == 0) {
          context.state.videoGrossCount = data
        }
      })
      // var res = await this.$http.get("/v1/index/videoInfoGrossCount");
      // var { code, data, message } = res.data;
      // if (code == 0) {
      //   this.videoGrossCount = data;
      // }
    },
    // 获取门类检索分类
    getTypeList: function (context) {
      axios.get('/v1/index/videoTypeList').then(res => {
        var { code, data } = res.data
        if (code == 0) {
          context.state.videoTwoCate = data
        }
      })
      // var res = await this.$http.get("/v1/index/videoTypeList");
      // var { code, data } = res.data;
      // if (code == 0) {
      //   this.videoTwoCate = data;
      // }
    },
    // 获取人物检索列表
    getPersonList: function (context) {
      axios.get('/v1/index/videoPersonList').then(res => {
        var { data, code } = res.data
        if (code == 0) {
          context.state.videoPerson = data
        }
      })
    },
    // 获取机构检索列表
    getOrgList: function (context) {
      axios.get('/v1/index/organizationList').then(res => {
        var { code, data } = res.data
        if (code == 0) {
          context.state.organizationList = data
        }
      })
    },
    // 高级检索
    highSearch: function (context) {
      let this_ = context.state
      // console.log(this_.page)
      axios.get(`/v1/index/highSearch?page=${this_.page}&limit=${
        this_.limit
      }&videoTypeId=${this_.videoTypeId}&videoCreateBeginTime=${this
        .startTime || ''}&videoCreateEndTime=${this_.endTime ||
        ''}&videoCategory=${this_.checkList}&personNameLike=${
        this_.checkedPersonList
      }&organizationLike=${this_.organizationLike}&status=${
        this_.showMode
      }&retrieval=${this_.retrieval}&address=${this_.address}&contentType=${
        this_.videoOneValue
      }&activityTitle=${this_.activeName}`).then(res => {
        var {code, data, message} = res.data
        if (code == 0) {
          console.log(data)
          this_.highSearchData = data
          this_.videoList = data.recordList
          // console.log(this_.videoList)
        } else {
          console.log(message)
        }
      }).catch(() => {

      })
    }
  }
})
export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js